export default __webpack_public_path__ + "static/media/pet-bottle-bales-2.fa7a456f.jpg";